import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgAuthPassword({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M12.71 7.15h-.64V5.22a4.08 4.08 0 00-8.14 0v1.93h-.64A1.3 1.3 0 002 8.44v5.14c0 .7.58 1.28 1.29 1.28h9.42c.71 0 1.29-.57 1.29-1.28V8.44a1.3 1.3 0 00-1.29-1.29zm-2.78 0H6.07V5.22a1.93 1.93 0 013.86 0v1.93z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgAuthPassword.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgAuthPassword.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgAuthPassword svgRef={ref} {...props} />);
export default ForwardRef;
